var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { useCallback, useState } from "react";
import { useQuery } from "react-query";
import { useOkapiKy } from "@folio/stripes/core";
import { usePageOffsetParam } from "./usePageOffsetParam";
import { fetchTitlesForVerification } from "../api/titleService";
import { fetchPeriodicalsForVerification } from "../api/periodicalLibraryService";
import { toTitleVerificationQueryParams, } from "../utils/titleVerificationFilters";
import { DEFAULT_TITLE_SORT } from "../utils/titleSort";
import { isCountCapped } from "../utils/exactCount";
import { useExactTotalCount } from "./useExactTotalCount";
import { usePageSize } from "./usePageSize";
var LIST_DEFAULT_PAGE_SIZE = 100;
export var useTitlesVerificationData = function (appliedFilters, type, sort) {
    var _a;
    if (sort === void 0) { sort = DEFAULT_TITLE_SORT; }
    var kyInstance = useOkapiKy();
    var _b = usePageOffsetParam(), pageOffset = _b.pageOffset, setPageOffset = _b.setPageOffset;
    var _c = usePageSize(LIST_DEFAULT_PAGE_SIZE), pageSize = _c.pageSize, setPageSize = _c.setPageSize;
    var _d = useState(0), totalRecords = _d[0], setTotalRecords = _d[1];
    var _e = useQuery(["titlesForVerification", type, appliedFilters, sort, pageOffset, pageSize], function () {
        var params = __assign(__assign({}, toTitleVerificationQueryParams(appliedFilters, type)), { sortBy: sort.sortBy, sortDir: sort.sortDir, offset: pageOffset, limit: pageSize });
        return type === "PERIODICAL"
            ? fetchPeriodicalsForVerification(kyInstance, params)
            : fetchTitlesForVerification(kyInstance, params);
    }, {
        enabled: true,
        keepPreviousData: true,
        onSuccess: function (responseData) {
            var _a;
            setTotalRecords((_a = responseData.totalRecords) !== null && _a !== void 0 ? _a : 0);
        },
    }), data = _e.data, isLoading = _e.isLoading, isFetching = _e.isFetching, isError = _e.isError, error = _e.error, refetch = _e.refetch;
    var totalRecordsExact = data === null || data === void 0 ? void 0 : data.totalRecordsExact;
    var exactTotalRecords = useExactTotalCount({
        queryKey: ["titlesForVerification", type, appliedFilters],
        fetchTotalRecords: function () { return __awaiter(void 0, void 0, void 0, function () {
            var params, response, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        params = __assign(__assign({}, toTitleVerificationQueryParams(appliedFilters, type)), { countOnly: true });
                        if (!(type === "PERIODICAL")) return [3 /*break*/, 2];
                        return [4 /*yield*/, fetchPeriodicalsForVerification(kyInstance, params)];
                    case 1:
                        _a = _b.sent();
                        return [3 /*break*/, 4];
                    case 2: return [4 /*yield*/, fetchTitlesForVerification(kyInstance, params)];
                    case 3:
                        _a = _b.sent();
                        _b.label = 4;
                    case 4:
                        response = _a;
                        return [2 /*return*/, response.totalRecords];
                }
            });
        }); },
        totalRecordsExact: totalRecordsExact,
    });
    var changePageSize = useCallback(function (size) {
        setPageSize(size);
        setPageOffset(0);
    }, [setPageSize, setPageOffset]);
    return {
        titlesData: (_a = data === null || data === void 0 ? void 0 : data.items) !== null && _a !== void 0 ? _a : [],
        totalRecords: exactTotalRecords !== null && exactTotalRecords !== void 0 ? exactTotalRecords : totalRecords,
        exactTotalRecords: exactTotalRecords,
        isCountCapped: isCountCapped(totalRecordsExact, exactTotalRecords),
        isLoading: isLoading,
        isFetching: isFetching,
        isError: isError,
        error: error,
        refetch: refetch,
        fetchMoreData: function (offset) { return setPageOffset(offset); },
        pageOffset: pageOffset,
        pageSize: pageSize,
        changePageSize: changePageSize,
    };
};
